// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screen_box {\n\twidth: 100%;\n\theight: 450px;\n\tbackground-color: black;\n}\n.screen_box > img {\n\tmax-width: 100%;\n}\n[popupClose] {\n\tposition: absolute;\n\ttop: 5px;\n\tleft: 5px;\n\twidth: 90%;\n\tfont-size: 15px;\n\tcolor: white;\n}\nbody {\n\toverflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
